// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.what-is-pamo-main-container {
  height: auto;
  padding-top: 30px;
  margin-bottom: 5%;
}
.what-is-pamo-main-container .what-is-pamo-header {
  font-size: 50px;
}
.what-is-pamo-main-container .what-is-pamo-body {
  font-size: 30px;
  line-height: 40px;
  margin: 0% 20%;
}

@media only screen and (max-width: 992px) {
  .what-is-pamo-header {
    font-size: 50px !important;
  }
  .what-is-pamo-body {
    font-size: 25px !important;
    line-height: 30px !important;
    margin: 0% 0% !important;
  }
}
@media only screen and (max-width: 767px) {
  .what-is-pamo-header {
    font-size: 40px !important;
  }
  .what-is-pamo-body {
    font-size: 18px !important;
    line-height: 20px !important;
  }
}
@media only screen and (max-width: 567px) {
  .what-is-pamo-header {
    font-size: 40px !important;
  }
  .what-is-pamo-body {
    font-size: 18px !important;
    line-height: 30px !important;
  }
}
@media only screen and (max-width: 600px) {
  .what-is-pamo-header {
    font-size: 30px !important;
  }
  .what-is-pamo-body {
    font-size: 15px !important;
    line-height: 20px !important;
    margin: 0% 10% !important;
  }
}
@media only screen and (max-width: 450px) {
  .what-is-pamo-header {
    font-size: 30px !important;
  }
  .what-is-pamo-body {
    font-size: 13px !important;
    line-height: 20px !important;
  }
  .what-is-pamo-link {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 400px) {
  .what-is-pamo-body {
    font-size: 13px !important;
  }
}
@media only screen and (max-width: 380px) {
  .what-is-pamo-body {
    font-size: 12px !important;
    line-height: 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/home/components/what-is-pamo/what-is-pamo.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,iBAAA;EACA,iBAAA;AACJ;AACI;EACI,eAAA;AACR;AACI;EACI,eAAA;EACA,iBAAA;EACA,cAAA;AACR;;AAIA;EACI;IACI,0BAAA;EADN;EAGE;IACI,0BAAA;IACA,4BAAA;IACA,wBAAA;EADN;AACF;AAME;EACE;IACI,0BAAA;EAJN;EAME;IACI,0BAAA;IACA,4BAAA;EAJN;AACF;AAOE;EACE;IACI,0BAAA;EALN;EAOE;IACI,0BAAA;IACA,4BAAA;EALN;AACF;AASE;EACE;IACI,0BAAA;EAPN;EASE;IACI,0BAAA;IACA,4BAAA;IACC,yBAAA;EAPP;AACF;AAWE;EACE;IACI,0BAAA;EATN;EAWE;IACI,0BAAA;IACA,4BAAA;EATN;EAYE;IACI,0BAAA;EAVN;AACF;AAaE;EACE;IACI,0BAAA;EAXN;AACF;AAgBE;EACE;IACI,0BAAA;IACA,4BAAA;EAdN;AACF","sourcesContent":[".what-is-pamo-main-container{\n    height:auto;\n    padding-top:30px;\n    margin-bottom:5%;\n\n    .what-is-pamo-header{\n        font-size:50px;\n    }\n    .what-is-pamo-body{\n        font-size:30px;\n        line-height:40px;\n        margin:0% 20% ;\n        \n    }\n}\n\n@media only screen and (max-width: 992px) {\n    .what-is-pamo-header{\n        font-size:50px !important;\n    }\n    .what-is-pamo-body{\n        font-size:25px !important;\n        line-height:30px !important;\n        margin:0% 0% !important;\n        // width:500px !important;\n        // width:100% !important;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .what-is-pamo-header{\n        font-size:40px !important;\n    }\n    .what-is-pamo-body{\n        font-size:18px !important;\n        line-height:20px !important;\n    }\n  }\n\n  @media only screen and (max-width: 567px) {\n    .what-is-pamo-header{\n        font-size:40px !important;\n    }\n    .what-is-pamo-body{\n        font-size:18px !important;\n        line-height:30px !important;\n    }\n  }\n\n\n  @media only screen and (max-width: 600px) {\n    .what-is-pamo-header{\n        font-size:30px !important;\n    }\n    .what-is-pamo-body{\n        font-size:15px !important;\n        line-height:20px !important;\n         margin:0% 10% !important;\n    }\n  }\n\n\n  @media only screen and (max-width: 450px) {\n    .what-is-pamo-header{\n        font-size:30px !important;\n    }\n    .what-is-pamo-body{\n        font-size:13px !important;\n        line-height:20px !important;\n        // margin:0% 3% !important;\n    }\n    .what-is-pamo-link{\n        font-size:13px !important;\n    }\n  }\n\n  @media only screen and (max-width: 400px) {\n    .what-is-pamo-body{\n        font-size:13px !important;\n        // line-height:10px !important;\n    }\n  }\n\n\n  @media only screen and (max-width: 380px) {\n    .what-is-pamo-body{\n        font-size:12px !important;\n        line-height:20px !important;\n    }\n   \n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
